export class FileModel {
  constructor(public fileBlob: File, public fileName: string) { }

  get getBase64(): Promise<string | ArrayBuffer> {
    const reader = new FileReader();
    reader.readAsDataURL(this.fileBlob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  }
}
